export default "__VITE_ASSET__hPSfQLZy__"